import { render, staticRenderFns } from "./formButtons.vue?vue&type=template&id=0271d2e7"
import script from "./formButtons.vue?vue&type=script&lang=js"
export * from "./formButtons.vue?vue&type=script&lang=js"
import style0 from "./formButtons.vue?vue&type=style&index=0&id=0271d2e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports